import * as requestFromServer from "../services/PublicCrudService";
import { objectsSlice, callTypes } from "../reduxSlices/objectsSlice";
import * as columnFormatters from "../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import {
  ToastType,
  ShowToast,
  setToastType,
} from "../../_metronic/_helpers/ToastHelpers";
//const {actions} = objectsSlice({name:""});

export const fetchObjects = (
  API_URL,
  sliceName,
  queryParams,
  getFunctionName
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.list }));

  if (API_URL === "forceEmpty") {
    const entities = null;
    const totalCount = 0;
    return dispatch(actions.objectsFetched({ totalCount, entities }));
  }

  return requestFromServer
    .findObjects(API_URL, queryParams, getFunctionName)
    .then((response) => {
      console.log("response.data :");
      console.log(response.data.data);
      const { totalCount, result: entities } = response.data.data;

      dispatch(actions.objectsFetched({ totalCount, entities }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchObjectsById = (
  API_URL,
  sliceName,
  id,
  queryParams,
  methodName
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });

  if (!id) {
    const totalCount = 0;
    const entities = null;
    return dispatch(actions.objectsFetched({ totalCount, entities }));
  }

  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findObjectsById(API_URL, id, queryParams, methodName)
    .then((response) => {
      const { totalCount, result: entities } = response.data.data;
      dispatch(actions.objectsFetched({ totalCount, entities }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchObjectsByParentId = (
  API_URL,
  sliceName,
  queryParams,
  parentId,
  parentName,
  secondId,
  secondName
) => (dispatch) => {
  const query = { ...queryParams };

  if (parentName !== "") {
    if (queryParams.whereClause === "") {
      query.whereClauseParameters = [];
      query.whereClause = `${parentName}=@0`;
      query.whereClauseParameters.push(parentId);

      if (secondName && secondName !== "") {
        query.whereClause = `${query.whereClause} and ${secondName}=@1`;
        query.whereClauseParameters.push(secondId);
      }
    }
  }

  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findObjects(API_URL, query)
    .then((response) => {
      console.log("response.data :");
      console.log(response.data.data);
      const { totalCount, result: entities } = response.data.data;

      dispatch(actions.objectsFetched({ totalCount, entities }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchSelectObjects = (
  API_URL,
  sliceName,
  queryParams,
  functionName
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  const temp = { ...queryParams };
  const query = {
    whereClause: "",
    whereClauseParameters: [],
    orderClause: "id asc ",
    skipCount: 0,
    takeCount: 1000,
    filter: {
      // title: "",
    },
  };

  query.filter = { ...temp.filter };

  switch (sliceName) {
    case "towns":
      if (temp.filter.provinceId > 0) {
        query.whereClause = query.whereClause + "provinceId=@0";
        query.whereClauseParameters.push(temp.filter.provinceId);
      } else {
        query.whereClause = query.whereClause + "provinceId!=@0";
        query.whereClauseParameters.push(0);
      }

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "forms":
      if (temp.filter.formTypeId > 0) {
        query.whereClause = query.whereClause + "formTypeId=@0";
        query.whereClauseParameters.push(temp.filter.formTypeId);
      } else {
        query.whereClause = query.whereClause + "formTypeId!=@0";
        query.whereClauseParameters.push(0);
      }

      if (temp.filter.questionId > 0) {
        query.whereClause = query.whereClause + " and questionId=@1";
        query.whereClauseParameters.push(temp.filter.questionId);
      } else {
        query.whereClause = query.whereClause + " and questionId!=@1";
        query.whereClauseParameters.push(0);
      }

      query.whereClause = query.whereClause + " and isDeleted=@2";
      query.whereClauseParameters.push(false);
      break;
    case "baseCategories":
      query.whereClause = query.whereClause + "parentCategoryId=@0";
      query.whereClauseParameters.push(null);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "placeCategories":
      query.whereClause = query.whereClause + "parentCategoryId=@0";
      query.whereClauseParameters.push(1);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "buildingCategories":
      query.whereClause = query.whereClause + "parentCategoryId=@0";
      query.whereClauseParameters.push(5);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "roomCategories":
      query.whereClause = query.whereClause + "parentCategoryId=@0";
      query.whereClauseParameters.push(3);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "seatCategories":
      query.whereClause = query.whereClause + "parentCategoryId=@0";
      query.whereClauseParameters.push(6);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "genderCategories":
      query.whereClause = query.whereClause + "parentCategoryId=@0";
      query.whereClauseParameters.push(62);

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "parentCategories":
      if (temp.filter.parentCategoryId > 0) {
        query.whereClause = query.whereClause + "parentCategoryId=@0";
        query.whereClauseParameters.push(temp.filter.parentCategoryId);
      } else {
        query.whereClause = query.whereClause + "parentCategoryId!=@0";
        query.whereClauseParameters.push(0);
      }

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "categories":
      if (temp.filter.parentCategoryId > 0) {
        query.whereClause = query.whereClause + "parentCategoryId=@0";
        query.whereClauseParameters.push(temp.filter.parentCategoryId);
      } else {
        query.whereClause = query.whereClause + "parentCategoryId!=@0";
        query.whereClauseParameters.push(0);
      }

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "places":
      // if (temp.filter.categoryId > 0) {
      //   query.whereClause = query.whereClause + "categoryId=@0"
      //   query.whereClauseParameters.push(temp.filter.categoryId)

      if (temp.filter.townId > 0) {
        query.whereClause = query.whereClause + "townId=@0";
        query.whereClauseParameters.push(temp.filter.townId);
      } else {
        query.whereClause = query.whereClause + "townId!=@0";
        query.whereClauseParameters.push(0);
      }
      // }
      // else {
      //   query.whereClause = query.whereClause + "categoryId!=@0"
      //   query.whereClauseParameters.push(0)
      // }
      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;

    case "buildings":
      if (temp.filter.categoryId > 0) {
        query.whereClause = query.whereClause + "categoryId=@0";
        query.whereClauseParameters.push(temp.filter.categoryId);
      } else {
        query.whereClause = query.whereClause + "categoryId!=@0";
        query.whereClauseParameters.push(0);
      }

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "auditBuildings":
      if (
        query.filter.auditPlaceId === undefined ||
        query.filter.auditPlaceId === 0
      )
        query.filter.auditPlaceId = -1;
      // if (temp.filter.categoryId > 0) {
      //   query.whereClause = query.whereClause + "categoryId=@0"
      //   query.whereClauseParameters.push(temp.filter.categoryId)
      // }
      // else {
      //   query.whereClause = query.whereClause + "categoryId!=@0"
      //   query.whereClauseParameters.push(0)
      // }
      break;
    case "floors":
      if (temp.filter.buildingId > 0) {
        query.whereClause = query.whereClause + "buildingId=@0";
        query.whereClauseParameters.push(temp.filter.buildingId);

        // if (temp.filter.categoryId > 0) {
        //   query.whereClause = query.whereClause + " and categoryId=@1"
        //   query.whereClauseParameters.push(temp.filter.categoryId)
        // }
      }
      // else if (temp.filter.categoryId > 0) {
      //   query.whereClause = query.whereClause + "categoryId=@0"
      //   query.whereClauseParameters.push(temp.filter.categoryId)
      // }
      else if (temp.filter.buildingId <= 0) {
        query.whereClause = query.whereClause + "buildingId=@0";
        query.whereClauseParameters.push(0);
      }

      break;
    case "rooms":
      if (temp.filter.floorId > 0) {
        query.whereClause = query.whereClause + "floorId=@0";
        query.whereClauseParameters.push(temp.filter.floorId);

        // if (temp.filter.categoryId > 0) {
        //   query.whereClause = query.whereClause + " and categoryId=@1"
        //   query.whereClauseParameters.push(temp.filter.categoryId)
        // }
      }
      // else if (temp.filter.categoryId > 0) {
      //   query.whereClause = query.whereClause + "categoryId=@0"
      //   query.whereClauseParameters.push(temp.filter.categoryId)
      // }
      else {
        query.whereClause = query.whereClause + "floorId=@0";
        query.whereClauseParameters.push(0);
      }

      query.whereClause = query.whereClause + " and isDeleted=@1";
      query.whereClauseParameters.push(false);
      break;
    case "seats":
      if (temp.filter.categoryId > 0) {
        query.whereClause = query.whereClause + "categoryId=@0";
        query.whereClauseParameters.push(temp.filter.categoryId);

        if (temp.filter.roomId > 0) {
          query.whereClause = query.whereClause + " and roomId=@1";
          query.whereClauseParameters.push(temp.filter.roomId);
        }
      } else if (temp.filter.categoryId > 0) {
        query.whereClause = query.whereClause + "categoryId=@0";
        query.whereClauseParameters.push(temp.filter.categoryId);
      } else {
        query.whereClause = query.whereClause + "categoryId=@0";
        query.whereClauseParameters.push(0);
      }
      break;
    case "auditPlaces":
      if (temp.filter.auditPeriodId > 0) {
        query.whereClause = query.whereClause + "auditPeriodId=@0";
        query.whereClauseParameters.push(temp.filter.auditPeriodId);

        query.whereClause = query.whereClause + " and allowed=@1";
        query.whereClauseParameters.push(true);
      } else {
        query.whereClause = query.whereClause + "auditPeriodId=@0";
        query.whereClauseParameters.push(0);
      }
      break;
    case "auditFormTypes":
      if (temp.filter.auditPeriodId > 0) {
        query.whereClause = query.whereClause + "auditPeriodId=@0";
        query.whereClauseParameters.push(temp.filter.auditPeriodId);

        query.whereClause = query.whereClause + " and allowed=@1";
        query.whereClauseParameters.push(true);
      } else {
        query.whereClause = query.whereClause + "auditPeriodId=@0";
        query.whereClauseParameters.push(0);
      }
      break;
    case "filterQuestions":
      if (temp.filter.auditFormTypeId > 0) {
        query.whereClause = query.whereClause + "formTypeId=@0";
        query.whereClauseParameters.push(temp.filter.auditFormTypeId);

        query.whereClause = query.whereClause + " and isDeleted=@1";
        query.whereClauseParameters.push(false);
      } else {
        query.whereClause = query.whereClause + "formTypeId=@0";
        query.whereClauseParameters.push(0);
      }
      break;

    // if (temp.filter.auditFormTypeId > 0) {
    //   query.whereClause = query.whereClause + "formTypeId=@0";
    //   query.whereClauseParameters.push(temp.filter.auditFormTypeId);


    //   if (temp.filter.categoryId > 0) {
    //     query.whereClause = query.whereClause + " and categoryId=@1";
    //     query.whereClauseParameters.push(temp.filter.categoryId);

    //     query.whereClause = query.whereClause + " and isDeleted=@2";
    //     query.whereClauseParameters.push(false);
    //   }
    //   else {
    //     query.whereClause = query.whereClause + " and categoryId=@1";
    //     query.whereClauseParameters.push(0);
    //   }

    // } else {
    //   query.whereClause = query.whereClause + "formTypeId=@0";
    //   query.whereClauseParameters.push(0);
    // }
    // break;
    case "filterAnswers":
      if (temp.filter.questionId > 0) {
        query.whereClause = query.whereClause + "questionId=@0";
        query.whereClauseParameters.push(temp.filter.questionId);

        query.whereClause = query.whereClause + " and isDeleted=@1";
        query.whereClauseParameters.push(false);
      } else {
        query.whereClause = query.whereClause + "questionId=@0";
        query.whereClauseParameters.push(0);
      }
      break;
    case "groups":
      break;
    case "subGroups":
      if (temp.filter.groupId > 0) {
        query.whereClause = query.whereClause + "groupId=@0";
        query.whereClauseParameters.push(temp.filter.groupId);
      } else {
        query.whereClause = query.whereClause + "groupId=@0";
        query.whereClauseParameters.push(0);
      }
      break;
    case "collages":
      break;
    case "fields":
      if (temp.filter.collageId > 0) {
        query.whereClause = query.whereClause + "collageId=@0";
        query.whereClauseParameters.push(temp.filter.collageId);
      } else {
        query.whereClause = query.whereClause + "collageId=@0";
        query.whereClauseParameters.push(0);
      }
      break;

    default:
      break;
  }

  // query.whereClause = temp.whereClauseSelect;
  // query.whereClauseParameters = temp.whereClauseParametersSelect;

  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .findObjects(API_URL, query, functionName)
    .then((response) => {
      console.log("response.data :");
      console.log(response.data.data);
      const { totalCount, result: entities } = response.data.data;

      dispatch(actions.objectsFetched({ totalCount, entities }));
    })
    .catch((error) => {
      //showError(error)
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchAllObjects = (API_URL, sliceName) => (dispatch) => {
  console.log(API_URL);
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getAllObjects(API_URL)
    .then((response) => {
      console.log("response.data :");
      console.log(response.data.data);
      const entities = response.data.data;

      dispatch(actions.allObjectsFetched({ entities }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.list }));
    });
};

export const fetchObjectByParentId = (
  API_URL,
  sliceName,
  parentId,
  parentName
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  var query = {};
  if (parentName !== "") {
    query = {
      whereClause: `${parentName}=@0`,
      whereClauseParameters: [parentId],
      orderClause: "id asc ",
      skipCount: 0,
      takeCount: 1,
    };
  }

  if (!parentId) {
    return dispatch(actions.objectFetched({ objectForEdit: undefined }));
  }
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .findObjects(API_URL, query)
    .then((response) => {
      const result = response.data.data;
      console.log("response.data :");
      console.log(result.result[0]);
      dispatch(actions.objectFetched({ objectForEdit: result.result[0] }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const fetchObject = (API_URL, sliceName, id, methodName) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });

  if (!id) {
    return dispatch(actions.objectFetched({ objectForEdit: undefined }));
  }

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getObjectById(API_URL, id, methodName)
    .then((response) => {
      const object = response.data.data;
      dispatch(actions.objectFetched({ objectForEdit: object }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteObject = (API_URL, sliceName, id, softDelete = true) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  if (softDelete) {
    return requestFromServer
      .deleteObject(API_URL, id)
      .then((response) => {
        ShowToast(
          "رکورد مورد نظر با موفقیت غیرفعالسازی شد.",
          ToastType.success
        );
        dispatch(actions.objectDeleted({ id }));
      })
      .catch((error) => {
        showError(error);
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  } else {
    return requestFromServer
      .hardDeleteObject(API_URL, id)
      .then((response) => {
        ShowToast("رکورد مورد نظر با موفقیت حذف شد.", ToastType.success);
        dispatch(actions.objectDeleted({ id }));
      })
      .catch((error) => {
        showError(error);
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  }
};

export const createObject = (
  API_URL,
  sliceName,
  objectForCreation,
  methodName
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createObject(API_URL, objectForCreation, methodName)
    .then((response) => {
      const object = response.data.data;
      ShowToast("رکورد جدید با موفقیت ایجاد شد.", ToastType.success);
      dispatch(actions.objectCreated({ object }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const createObjectWithoutResult = (
  API_URL,
  sliceName,
  objectForCreation,
  methodName
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .createObject(API_URL, objectForCreation, methodName)
    .then((response) => {
      // const object = response.data.data;
      // ShowToast("رکورد جدید با موفقیت ایجاد شد.", ToastType.success);
      // dispatch(actions.objectCreated({ object }));
      dispatch(actions.catchError({ undefined, callType: callTypes.action }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObject = (API_URL, sliceName, object) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });

  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateObject(API_URL, object)
    .then(() => {
      ShowToast("رکورد جدید با موفقیت ویرایش شد.", ToastType.success);
      dispatch(actions.objectUpdated({ object }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjects = (
  API_URL,
  sliceName,
  ids,
  object,
  functionName
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateObjects(API_URL, ids, object, functionName)
    .then(() => {
      ShowToast(
        columnFormatters.translateByMessageIdParam("HTTP.STATUS.2xx"),
        ToastType.success
      );
      dispatch(actions.objectsUpdated({ ids, object }));
    })
    .catch((error) => {
      showError(error);
      //console.log("generalActions error.message =>  " + error.message);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateSeatResultsFromUserObject = (
  API_URL,
  sliceName,
  id,
  ids,
  userObj,
  methodName
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateSeatResultsFromUserObject(API_URL, id, ids, userObj, methodName)
    .then(() => {
      ShowToast("پرسشنامه با موفقیت تکمیل شد.", ToastType.success);
      dispatch(actions.objectsResultStatusUpdated({ ids, status: "Temp" }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjectsResultStatus = (
  API_URL,
  sliceName,
  id,
  ids,
  status,
  methodName
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateResultStatusObjects(API_URL, id, ids, { status }, methodName)
    .then(() => {
      ShowToast("پرسشنامه با موفقیت تایید شد.", ToastType.success);
      dispatch(actions.objectsResultStatusUpdated({ ids, status }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const UPDATE_FORM_STATUS = 'UPDATE_FORM_STATUS';

export const updateFormStatus = (formId, newStatus) => {
  return {
    type: UPDATE_FORM_STATUS,
    payload: {
      formId,
      newStatus,
    },
  };
};

export const updateAuditFormListStatus = (id, status) => (dispatch) => {
  const API_URL = 'api/AuditFormList';
  const object = { id, status };

  dispatch({ type: 'UPDATE_AUDIT_FORM_LIST_STATUS_REQUEST' });

  return requestFromServer.updateObject(API_URL, object)
    .then(() => {
      ShowToast("وضعیت فرم با موفقیت بروزرسانی شد.", ToastType.success);
      dispatch({
        type: 'UPDATE_AUDIT_FORM_LIST_STATUS_SUCCESS',
        payload: { id, status },
      });
    })
    .catch((error) => {
      showError(error);
      dispatch({
        type: 'UPDATE_AUDIT_FORM_LIST_STATUS_FAILURE',
        error,
      });
    });
};


export const updateObjectsAllowed = (API_URL, sliceName, ids, allowed) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateObjects(API_URL, ids, { allowed })
    .then(() => {
      // ShowToast("اجازه دسترسی رکوردهای مورد نظر با موفقیت به روز رسانی شد.", ToastType.success);
      dispatch(actions.objectsAllowedUpdated({ ids, allowed }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjectsAuditOption = (API_URL, sliceName, ids, allowed) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateObjects(API_URL, ids, { allowed })
    .then(() => {
      ShowToast(
        "وضعیت رکوردهای مورد نظر با موفقیت به روز رسانی شد.",
        ToastType.success
      );
      dispatch(actions.objectsAuditOptionUpdated({ ids, allowed }));
    })
    .catch((error) => {
      error.clientMessage = "خطا در دریافت اطلاعات";
      if (error.response) {
        error.clientMessage = columnFormatters.translateByMessageIdParam(
          "HTTP.STATUS.4xx",
          error.response.status
        );
      } else if (error.request) {
        error.clientMessage = columnFormatters.translateByMessageIdParam(
          "HTTP.STATUS.5xx",
          error.message
        );
      } else {
        error.clientMessage = columnFormatters.translateByMessageIdParam(
          "HTTP.STATUS.NETERROR",
          error.message
        );
      }

      console.log("generalActions error.message =>  " + error.message);
      ShowToast(error.clientMessage, ToastType.error);

      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjectsFullAccess = (
  API_URL,
  sliceName,
  ids,
  isFullAccess
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateObjects(API_URL, ids, { isFullAccess })
    .then(() => {
      ShowToast(
        "سطح دسترسی رکوردهای مورد نظر با موفقیت به روز رسانی شد.",
        ToastType.success
      );
      dispatch(actions.objectsFullAccessUpdated({ ids, isFullAccess }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjectsHoliday = (API_URL, sliceName, ids, holiday) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateObjects(API_URL, ids, { holiday })
    .then(() => {
      ShowToast(
        "وضعیت رکوردهای مورد نظر با موفقیت به روز رسانی شد.",
        ToastType.success
      );
      dispatch(actions.objectsHolidayUpdated({ ids, holiday }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateObjectsStatus = (API_URL, sliceName, ids, isDeleted) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .updateStatusForObjects(API_URL, ids, isDeleted)
    .then(() => {
      ShowToast(
        "وضعیت رکوردهای مورد نظر با موفقیت به روز رسانی شد.",
        ToastType.success
      );
      dispatch(actions.objectsStatusUpdated({ ids, isDeleted }));
    })
    .catch((error) => {
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const deleteObjects = (API_URL, sliceName, ids, softDelete = true) => (
  dispatch
) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  if (softDelete) {
    return requestFromServer
      .deleteObjects(API_URL, ids)
      .then(() => {
        ShowToast(
          "رکوردهای مورد نظر با موفقیت غیرفعالسازی شد.",
          ToastType.success
        );
        dispatch(actions.objectsDeleted({ ids }));
      })
      .catch((error) => {
        showError(error);
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  } else {
    return requestFromServer
      .hardDeleteObjects(API_URL, ids)
      .then(() => {
        ShowToast("رکوردهای مورد نظر با موفقیت حذف شد.", ToastType.success);
        dispatch(actions.objectsDeleted({ ids }));
      })
      .catch((error) => {
        showError(error);
        dispatch(actions.catchError({ error, callType: callTypes.action }));
      });
  }
};

export const downloadExcelFile = (
  API_URL,
  sliceName,
  queryParams,
  funcName
) => (dispatch) => {
  const { actions } = objectsSlice({ name: sliceName });
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getFile(API_URL, queryParams, funcName)
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", generateFileName("Report", ".xlsx"));
      document.body.appendChild(link);
      link.click();
      dispatch(actions.catchError({ undefined, callType: callTypes.action }));
    })
    .catch((error) => {
      //console.log("download error");
      //console.log(error);
      showError(error);
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

function generateFileName(fileName, fileType) {
  let nowDateTime = new Date();
  let nowTime = nowDateTime.toLocaleTimeString("en-US", {
    hour12: false,
    hour: "numeric",
    minute: "numeric",
  });

  let nowDate = nowDateTime.toLocaleDateString("en-US");
  return fileName + "_Date_" + nowDate + "_Time_" + nowTime + fileType;
}

function showError(error) {
  error.clientMessage = "خطا در دریافت اطلاعات";
  // console.log("generalActions error =>  " + JSON.stringify(error));
  // Error 😨
  if (error.response) {
    /*
     * The request was made and the server responded with a
     * status code that falls out of the range of 2xx - error 4XX
     */
    error.clientMessage = columnFormatters.translateByMessageIdParam(
      // "HTTP.STATUS.4xx",
      error.response.data.Message,
      error.response.status
    );
  } else if (error.request) {
    /*
     * The request was made but no response was received, `error.request`
     * is an instance of XMLHttpRequest in the browser and an instance
     * of http.ClientRequest in Node.js
     */
    error.clientMessage = columnFormatters.translateByMessageIdParam(
      // "HTTP.STATUS.5xx",
      error.request.responseText,
      error.message
    );
  } else {
    // Something happened in setting up the request and triggered an Error  - error Network
    // error.clientMessage = intl.formatMessage({ id: "HTTP.STATUS.NETERROR", values: { COUNT: `${error.message}` } });
    error.clientMessage = columnFormatters.translateByMessageIdParam(
      "HTTP.STATUS.NETERROR",
      error.message
    );
  }

  ShowToast(error.clientMessage, ToastType.error);
}
